function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from "react";
import { Button } from "../../atoms";
import { LightArrowLeft, LightArrowRight } from "../../visuals";
var LegacySimulatorAction = function(param) {
    var t = param.t, stepState = param.stepState, _param_canContinue = param.canContinue, canContinue = _param_canContinue === void 0 ? false : _param_canContinue;
    var _stepState = _sliced_to_array(stepState, 2), stepIndex = _stepState[0], setStepIndex = _stepState[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full h-auto flex flex-row justify-center items-center gap-3"
    }, stepIndex !== 1 && /*#__PURE__*/ React.createElement(Button, {
        type: "icon-before",
        variant: "secondary",
        icon: /*#__PURE__*/ React.createElement(LightArrowLeft, null),
        label: t("back"),
        className: "bg-orange-50 text-red-500 font-bold py-3",
        onClick: function() {
            return setStepIndex(stepIndex - 1);
        }
    }), stepIndex !== 4 && /*#__PURE__*/ React.createElement(Button, {
        type: "icon-after",
        variant: "primary",
        icon: /*#__PURE__*/ React.createElement(LightArrowRight, null),
        label: t("continue"),
        onClick: function() {
            return setStepIndex(stepIndex + 1);
        },
        className: "font-bold py-3",
        disabled: !canContinue
    }));
};
export default LegacySimulatorAction;

//# sourceMappingURL=LegacySimulatorAction.js.map